import { render, staticRenderFns } from "./NavBarRoot.vue?vue&type=template&id=8876c528&scoped=true"
import script from "./NavBarRoot.vue?vue&type=script&lang=js"
export * from "./NavBarRoot.vue?vue&type=script&lang=js"
import style0 from "./NavBarRoot.vue?vue&type=style&index=0&id=8876c528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8876c528",
  null
  
)

export default component.exports